import PropTypes from 'prop-types';
import styled from 'styled-components';

import CenterMixin from '../../themes/components/Center';

const Center = styled.div`
  ${CenterMixin}
`;

Center.propTypes = {
  /** Center content */
  children: PropTypes.node,
  /** No margin styling */
  noMargin: PropTypes.bool,
};

/** @component */
export default Center;
